import { Injectable } from '@angular/core';
import {MapsTypesAvailabilityDto} from '../dto/MapsTypesAvailabilityDto';
import {catchError, Observable, retry} from 'rxjs';
import {MapsTypesAvailabilityModel} from '../models/mapsTypesAvailabilityModel';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {MatSnackBar} from '@angular/material/snack-bar';
import {CookieService} from 'ngx-cookie-service';
import {TranslateService} from '@ngx-translate/core';
import {BaseService} from './base.service';

export interface OrderingDefinition {
  id: number;
  name: string;
  analysisType: string;
  isDefault: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ReportService extends BaseService {

  private API_REPORT_URL = this.API_ADMIN_BASE_URL + "v1/reporting/api";

  constructor(
      private httpClient: HttpClient,
      public _snackBar: MatSnackBar,
      public cookieService: CookieService,
      public translate: TranslateService) {
    super();
  }

    getOrderingDefinitions(analysisType: string): Observable<OrderingDefinition[]> {
        return this.httpClient.get<OrderingDefinition[]>(this.API_REPORT_URL + "/analysis/ordering-definitions?analysisType=" + encodeURIComponent(analysisType))
            .pipe(
                catchError(err => {
                    this.hasError.next(true);
                    this._snackBar.open(this.translate.instant('DATA-SERVICE.GENERATE-REPORT-ERROR'), this.translate.instant('SNACKBAR.DISMISS'), {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }

    getChemicalCompareElementOrder(): Observable<number[]> {
        return this.httpClient.get<number[]>(this.API_REPORT_URL + "/analysis/chemical-compare/element-order")
            .pipe(
                catchError(err => {
                    this.hasError.next(true);
                    this._snackBar.open(this.translate.instant('DATA-SERVICE.GENERATE-REPORT-ERROR'), this.translate.instant('SNACKBAR.DISMISS'), {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }

    generateFieldAnalysisReport(type: string, period: number, fieldId: string, addGoogleMapsPage: boolean = true, addReportCoverPage: boolean = true, orderingDefinitionId?: number, language: string = 'en', orientation: string = 'portrait', labelSize?: number, labelColor?: string, labelStrokeColor?: string): Observable<any> {
        let url = this.API_REPORT_URL + "/analysis/field/" + fieldId + "/general?period=" + period + "&type=" + type.replace(/\s+/g,'') + "&addGoogleMapsPage=" + addGoogleMapsPage + "&addReportCoverPage=" + addReportCoverPage + "&language=" + language + "&orientation=" + orientation;
        if (orderingDefinitionId) {
            url += "&orderingDefinitionId=" + orderingDefinitionId;
        }
        if (labelSize) {
            url += "&labelSize=" + labelSize;
        }
        if (labelColor) {
            url += "&labelColor=" + encodeURIComponent(labelColor);
        }
        if (labelStrokeColor) {
            url += "&labelStrokeColor=" + encodeURIComponent(labelStrokeColor);
        }
        return this.httpClient.post<any>(url, {responseType: 'text' })
            .pipe(
                catchError(err => {
                    this.hasError.next(true);
                    this._snackBar.open(this.translate.instant('DATA-SERVICE.GENERATE-REPORT-ERROR'), this.translate.instant('SNACKBAR.DISMISS'), {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }

    generateFieldSatelliteAnalysisReport(type: string, startDate: string, endDate: string, fieldId: string, addGoogleMapsPage: boolean = true, addReportCoverPage: boolean = true): Observable<any> {

      return this.httpClient.post<any>(this.API_REPORT_URL + "/analysis/field/" + fieldId + "/satellite?startDate=" + startDate + "&endDate=" + endDate + "&type=" + type + "&addGoogleMapsPage=" + addGoogleMapsPage + "&addReportCoverPage=" + addReportCoverPage, {responseType: 'text' })
          .pipe(
              catchError(err => {
                  this.hasError.next(true);
                  this._snackBar.open(this.translate.instant('DATA-SERVICE.GENERATE-REPORT-ERROR'), this.translate.instant('SNACKBAR.DISMISS'), {
                      duration: 5000,
                  });
                  this.hasError.next(false);
                  return this.errorHandler(err);
              })
        );
  }

    generateFarmAnalysisReport(type: string, period: number, farmId: string, addGoogleMapsPage: boolean = true, addReportCoverPage: boolean = true, orderingDefinitionId?: number, language: string = 'en', orientation: string = 'portrait', labelSize?: number, fieldIds?: number[], labelColor?: string, labelStrokeColor?: string): Observable<any> {
        let url = this.API_REPORT_URL + "/analysis/farm/" + farmId + "/general?period=" + period + "&type=" + type.toLowerCase().replace(/\s+/g,'') + "&addGoogleMapsPage=" + addGoogleMapsPage + "&addReportCoverPage=" + addReportCoverPage + "&language=" + language + "&orientation=" + orientation;
        if (orderingDefinitionId) {
            url += "&orderingDefinitionId=" + orderingDefinitionId;
        }
        if (labelSize) {
            url += "&labelSize=" + labelSize;
        }
        if (fieldIds && fieldIds.length > 0) {
            url += "&fieldIds=" + fieldIds.join(",");
        }
        if (labelColor) {
            url += "&labelColor=" + encodeURIComponent(labelColor);
        }
        if (labelStrokeColor) {
            url += "&labelStrokeColor=" + encodeURIComponent(labelStrokeColor);
        }
        return this.httpClient.post<any>(url, {responseType: 'text' })
              .pipe(
                  catchError(err => {
                    this.hasError.next(true);
                    this._snackBar.open(this.translate.instant('DATA-SERVICE.GENERATE-REPORT-ERROR'), this.translate.instant('SNACKBAR.DISMISS'), {
                      duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                  })
              );
    }

}
